import * as React from 'react';

const ShieldWithCheckFillSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={16} height={16} fill="none" {...props}>
        <path
            d="M8 .667L2 3.333v4c0 3.7 2.56 7.16 6 8 3.44-.84 6-4.3 6-8v-4L8 .667zM6.667 11.333L4 8.667l.94-.94 1.727 1.72 4.393-4.394L12 6l-5.333 5.333z"
            fill="#39364F"
        />
    </svg>
);

ShieldWithCheckFillSvg.displayName = 'ShieldWithCheckFillSvg';
export default ShieldWithCheckFillSvg;
